var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-input-invite"
  }, [_c('div', {
    staticClass: "box",
    on: {
      "click": _vm.clickLinkInvite
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/invite-member.svg")
    }
  }), _vm._m(0)]), _c('div', {
    staticClass: "box",
    on: {
      "click": _vm.clickEmailInvite
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/invite-email.svg")
    }
  }), _vm._m(1)]), _vm.isEmailInvite ? _c('progress-input-email-invite', {
    on: {
      "close": _vm.hideInvite,
      "submit": _vm.submit
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txtbox"
  }, [_c('p', [_vm._v("링크로 초대하기")]), _c('span', [_vm._v("링크를 공유하여 연구원들을 초대하세요")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txtbox"
  }, [_c('p', [_vm._v("이메일로 초대하기")]), _c('span', [_vm._v("초대할 연구원들에게 메일을 보내세요.")])]);
}]

export { render, staticRenderFns }